export const productNameMap: Record<string, string> = {
  subtitle_basic: 'minuteExperiencePack',
  subtitle_standard: 'minuteProfessionPack',
  subtitle_premium: 'minuteEnjoyPack',
  subtitle_deluxe: 'minuteDeluxePack',
  // TODO: 企业版
  subtitle_business_discovery: 'minuteDiscoveryPackBusiness',
  subtitle_business_essential: 'minuteEssentialPackBusiness',
  subtitle_business_professional: 'minuteProfessionalPackBusiness',
  subtitle_business_premium: 'minutePremiumPackBusiness',
  // 注册用户赠送
  subtitle_trail: 'modePayment.gift',
  // 邀请赠送
  subtitle_quota_invitation: 'modePayment.invite',
  // 迁移额度
  subtitle_migration: 'modePayment.gift',

};

export const productPaymentMap: Record<string, string> = {
  QUOTA: 'modePayment.gift',
  PURCHASE: 'modePayment.recharge',
};
